import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { addRegisteredLayout } from "../layoutDescriptions";
import { Grid, IconButton, Modal, Typography } from "@material-ui/core";
import { Panel } from "../../../panel";
import { useStyles } from "./styles";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import { Formik, useFormikContext } from "formik";
const mainPanelSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true
    }
};
const panelSettings = {
    main: mainPanelSettings,
    actions: {}
};
addRegisteredLayout({
    name: "ModalPopup",
    displayName: "ModalPopup",
    panels: panelSettings,
    canDecideMaxWidth: true
});
var ModalCloseModeEnum;
(function (ModalCloseModeEnum) {
    ModalCloseModeEnum[ModalCloseModeEnum["EnableDefaultClose_And_EnableCloseOnSubmit"] = 1] = "EnableDefaultClose_And_EnableCloseOnSubmit";
    ModalCloseModeEnum[ModalCloseModeEnum["EnableDefaultClose_And_DisableCloseOnSubmit"] = 2] = "EnableDefaultClose_And_DisableCloseOnSubmit";
    ModalCloseModeEnum[ModalCloseModeEnum["DisableDefaultClose_And_EnableCloseOnSubmit"] = 3] = "DisableDefaultClose_And_EnableCloseOnSubmit";
    ModalCloseModeEnum[ModalCloseModeEnum["DisableDefaultClose_And_DisableCloseOnSubmit"] = 4] = "DisableDefaultClose_And_DisableCloseOnSubmit";
})(ModalCloseModeEnum || (ModalCloseModeEnum = {}));
export const ModalPopup = (props) => {
    const { panels, maxWidth, pageTitle, modalClick, modalCloseMode = ModalCloseModeEnum.EnableDefaultClose_And_EnableCloseOnSubmit, formIsDisabled } = props;
    const { main, actions } = panels;
    const classes = useStyles(props);
    const pageDefinedPanelSpecificProps = { maxWidth };
    const [open, setOpen] = useState(true);
    const { submitForm, setValues, initialValues, values, ...formikProps } = useFormikContext();
    useEffect(() => {
        setOpen(true);
    }, [modalClick]);
    return (_jsx(Modal, { className: classes.modal, open: open, onClose: () => {
            if (modalCloseMode ===
                ModalCloseModeEnum.EnableDefaultClose_And_EnableCloseOnSubmit ||
                modalCloseMode ===
                    ModalCloseModeEnum.EnableDefaultClose_And_DisableCloseOnSubmit) {
                setOpen(!open);
            }
        }, children: _jsx(Formik, { initialValues: values, enableReinitialize: true, onSubmit: async (values) => {
                setValues(values);
                await submitForm();
                if (modalCloseMode ===
                    ModalCloseModeEnum.EnableDefaultClose_And_EnableCloseOnSubmit ||
                    modalCloseMode ===
                        ModalCloseModeEnum.DisableDefaultClose_And_EnableCloseOnSubmit) {
                    setOpen(false);
                }
            }, ...formikProps, children: _jsxs(Grid, { container: true, spacing: 3, justifyContent: "center", className: clsx(classes.pageMaxWidth, classes.modalInternalGrid), direction: "column", children: [_jsxs(Grid, { item: true, container: true, direction: "row", style: { justifyContent: "space-between" }, children: [_jsx(Grid, { item: true, children: _jsx(Typography, { variant: "h5", children: pageTitle }) }), _jsx(Grid, { item: true, children: _jsx(IconButton, { onClick: () => setOpen(!open), children: _jsx(CloseIcon, {}) }) })] }), _jsxs("div", { style: {
                            pointerEvents: formIsDisabled ? "none" : "auto",
                            opacity: formIsDisabled ? 0.6 : 1,
                            transition: "opacity 0.2s ease-in-out"
                        }, children: [_jsx(Grid, { item: true, xs: 12, md: 12, children: main && (_jsx(Panel, { transparent: true, ...pageDefinedPanelSpecificProps, ...main })) }), actions && (_jsx(Grid, { item: true, xs: 12, md: 12, children: _jsx(Panel, { transparent: true, justifyContent: "center", ...pageDefinedPanelSpecificProps, ...actions }) }))] })] }) }) }));
};
ModalPopup.displayName = "DployFormModalPopup";
//# sourceMappingURL=ModalPopup.js.map